import styled from "styled-components";
import {flexRowContainerMixin} from "../../../../../../../themes/architecture/css-helpers/flex";

export const OptInHeaderRowContainerBox = styled.div`
    display: flex;
    align-items: center;
    ${flexRowContainerMixin}

`